import { render, staticRenderFns } from "./waitMe.vue?vue&type=template&id=249fc9e3&scoped=true&"
import script from "./waitMe.vue?vue&type=script&lang=js&"
export * from "./waitMe.vue?vue&type=script&lang=js&"
import style0 from "./waitMe.vue?vue&type=style&index=0&id=249fc9e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249fc9e3",
  null
  
)

export default component.exports